import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { addLog } from 'assets/components/feedback/Feedback';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { HttpStatus } from 'config/Api.Config';
import claimTypeAutomationRuleDeleteApi from 'models/claims/claimTypeAutomationRule/delete/Api.ClaimTypeAutomationRule.Delete';
import AutomationRulesTable from 'module/automation/components/Automation.Rule.Table';
import { createRule } from 'module/automation/helpers/ruleHelpers';
import { createClaimAutomationSchema } from 'module/automation/schemas/ClaimAutomationSchema';
import { useState } from 'react';
import { useClaimTypeProvider } from '../../../ClaimType.Hooks';
import ClaimTypeAutomationRuleEditForm from './ClaimType.Edit.AutomationRuleEditForm';

export default function ClaimTypeEditAutomationRules() {
  const { lang } = getLocales();
  const { form } = useModalForm<Api.Core.ClaimType.Save.IRequest>();
  const [currentRule, setCurrentRule] = useState<Partial<Model.IClaimTypeAutomationRule>>(null);
  const { automationClaimStatuses, automationClaimJobStatuses } = useClaimTypeProvider();
  const schema = createClaimAutomationSchema({
    claimStatuses: automationClaimStatuses,
    claimJobStatuses: automationClaimJobStatuses,
  });
  const rules = form.data?.claimTypeAutomationRules ?? [];

  const deleteRule = async (ruleId?: number) => {
    if (!ruleId || ruleId < 1) return;

    const res = await claimTypeAutomationRuleDeleteApi(ruleId);
    if (res.status !== HttpStatus.ok) {
      addLog({ error: res.message });
    }
  };

  return (
    <FormWrapper>
      <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <Button
          class={ThemeButtonCircle}
          render={lang.addNew}
          active
          disabled={rules.length >= 1}
          data={createRule(schema, { id: -1 * (rules.length + 1) })}
          onClick={setCurrentRule}
        />
      </Box>

      {currentRule && (
        <ClaimTypeAutomationRuleEditForm
          data={currentRule}
          onCancel={() => setCurrentRule(null)}
          onSave={(newRule) => {
            const filteredRules = rules.filter((it) => it?.id !== newRule?.id);
            form.update({ claimTypeAutomationRules: [...filteredRules, newRule] });
            setCurrentRule(null);
          }}
        />
      )}

      <AutomationRulesTable<Model.IClaimTypeAutomationRule>
        value={form.data?.claimTypeAutomationRules as Model.IClaimTypeAutomationRule[]}
        schema={schema}
        hideAddRule
        onChange={(updatedRules) => form.update({ claimTypeAutomationRules: updatedRules })}
        onDeleteRule={(_, rule) => deleteRule(rule?.id)}
      />
    </FormWrapper>
  );
}
